<template>
  <div class="footer">
    <div class="footer_left">
      <img class="footer_left__img" src="@/assets/images/logo2.png" alt />
    </div>

    <div class="footer_center">
      <div>学赚计划：<span class="footer_center_text" @click="handleShare2()">https://github.com/hitadao</span></div>
      <div>捐献地址：<span class="footer_center_text2" @click="copyText()">hitadao.eth<i class="el-icon-document-copy" style="margin: 0 0 0 12px;"></i></span></div>
    </div>

    <ul class="hs_share_ul">
      <li class="hs_share_li" v-for="(item, index) in shareList" :key="index">
        <img
          @click="handleShare(item)"
          :src="item.img"
          class="hs_share_li_img"
          alt
          @mouseleave="removeHoverStyle(index)"
        />
        <div class="hs_share_li_div" @click="handleShare(item)" :id="'share' + index"></div>
      </li>
    </ul>
  </div>
</template>

<script>
import Vue from "vue";
import Clipboard from 'clipboard';
import { Message } from "element-ui";
Vue.prototype.$message = Message;
export default {
  props: ["black"],
  data() {
    return {
      shareList: [
        {
          img: "https://bucket-files-web3.oss-cn-hongkong.aliyuncs.com/community/share_1_1.png",
          url: "https://x.com/hita_dao",
        },
        {
          img: "https://bucket-files-web3.oss-cn-hongkong.aliyuncs.com/community/share_2_2.png",
          url: "https://discord.gg/RTQzWkTF",
        },
        {
          img: "https://bucket-files-web3.oss-cn-hongkong.aliyuncs.com/community/share_4_4.png",
          url: "https://t.me/+Wvs9ML0Ll9YxYjJl",
        },
        {
          img: "https://bucket-files-web3.oss-cn-hongkong.aliyuncs.com/community/share_3_3.png",
          url: "https://github.com/hitadao",
        },
        // {
        //   img: 'https://bucket-files-web3.oss-cn-hongkong.aliyuncs.com/community/share_5.png',
        //   url: ""
        // },
      ], // 分享
    };
  },
  methods: {
    // 分享
    handleShare(item) {
      if (item.url != "") {
        window.open(item.url, "_blank");
      }
    },
    handleShare2() {
      window.open('https://github.com/hitadao', "_blank");
    },
    // 移出触发样式
    removeHoverStyle(index) {
      // 移除hover样式的逻辑
      document.getElementById("share" + index).classList.add("hs_share_li_div");
      setTimeout(() => {
        document
          .getElementById("share" + index)
          .classList.remove("hs_share_li_div");
      }, 100); // 0.1秒后执行
    },
    copyText() {
      var text = 'hitadao.eth';
      const clipboard = new Clipboard('.footer_center_text2', {
        text() {
          return text;
        }
      });
      clipboard.on('success', () => {
        this.$message.success('链接已复制！');
        clipboard.destroy();
      });
      clipboard.on('error', e => {
        console.log('该浏览器不支持自动复制!', 'warning', e);
        clipboard.destroy();
      });
    }
  },
  mounted() {
    for (var index = 0; index < 4; index++) {
      document
        .getElementById("share" + index)
        .classList.remove("hs_share_li_div");
    }
  },
};
</script>

<style lang="scss" scoped>
.footer {
  width: 92%;
  height: 200px;
  background: #00092B;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 4% 0 4%;

  .footer_left {
    width: 182px;
    height: 61px;

    display: flex;
    justify-content: center;
    align-items: center;
    &__img {
      width: 182px;
      height: 61px;
      object-fit: contain;
      background: none;
    }
  }

  .footer_center {
    font-weight: normal;
    font-size: 20px;
    color: #FFFFFF;
    line-height: 2em;
    text-align: left;
    font-style: normal;
    text-transform: none;

    .footer_center_text:hover {
      cursor: pointer;
      text-decoration: underline;
    }

    .footer_center_text2:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }

  .hs_share_ul {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 0 0 0;

    .hs_share_li {
      width: 47px;
      height: 46px;
      margin: 0 19px 0 19px;
      border-radius: 50%;

      .hs_share_li_img {
        width: 47px;
        height: 46px;
        object-fit: contain;
        cursor: pointer;
      }

      .hs_share_li_div {
        position: absolute;
        width: 47px;
        height: 46px;
        margin: -46px 0 0 0;
        border-radius: 50%;
        background-color: rgba(255, 255, 255, 0.6);
        cursor: pointer;
      }
    }

    .hs_share_li:hover {
      box-shadow: 0px 0 8px 8px rgba(255, 255, 255, 0.4);
      border-radius: 50%;
    }
  }
}

@media screen and (max-width: 1120px){ 
  .footer {
  width: 92%;
  height: 200px;
  background: #00092B;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 4% 0 4%;

  .footer_left {
    width: 182px;
    height: 61px;

    display: flex;
    justify-content: center;
    align-items: center;

    display: none;
    &__img {
      width: 182px;
      height: 61px;
      object-fit: contain;
      background: none;
    }
  }

  .footer_center {
    font-weight: normal;
    font-size: 20px;
    color: #FFFFFF;
    line-height: 2em;
    text-align: left;
    font-style: normal;
    text-transform: none;

    .footer_center_text:hover {
      cursor: pointer;
      text-decoration: underline;
    }

    .footer_center_text2:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }

  .hs_share_ul {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 0 0 0;

    .hs_share_li {
      width: 47px;
      height: 46px;
      margin: 0 19px 0 19px;
      border-radius: 50%;

      .hs_share_li_img {
        width: 47px;
        height: 46px;
        object-fit: contain;
        cursor: pointer;
      }

      .hs_share_li_div {
        position: absolute;
        width: 47px;
        height: 46px;
        margin: -46px 0 0 0;
        border-radius: 50%;
        background-color: rgba(255, 255, 255, 0.6);
        cursor: pointer;
      }
    }

    .hs_share_li:hover {
      box-shadow: 0px 0 8px 8px rgba(255, 255, 255, 0.4);
      border-radius: 50%;
    }
  }
}
}

@media screen and (max-width: 800px){ 
  .footer {
  width: 92%;
  height: 200px;
  background: #00092B;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 4% 0 4%;

  .footer_left {
    width: 182px;
    height: 61px;

    display: flex;
    justify-content: center;
    align-items: center;

    display: none;
    &__img {
      width: 182px;
      height: 61px;
      object-fit: contain;
      background: none;
    }
  }

  .footer_center {
    font-weight: normal;
    font-size: 20px;
    color: #FFFFFF;
    line-height: 2em;
    text-align: left;
    font-style: normal;
    text-transform: none;

    .footer_center_text:hover {
      cursor: pointer;
      text-decoration: underline;
    }

    .footer_center_text2:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }

  .hs_share_ul {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 0 0 0;

    display: none;

    .hs_share_li {
      width: 47px;
      height: 46px;
      margin: 0 19px 0 19px;
      border-radius: 50%;

      .hs_share_li_img {
        width: 47px;
        height: 46px;
        object-fit: contain;
        cursor: pointer;
      }

      .hs_share_li_div {
        position: absolute;
        width: 47px;
        height: 46px;
        margin: -46px 0 0 0;
        border-radius: 50%;
        background-color: rgba(255, 255, 255, 0.6);
        cursor: pointer;
      }
    }

    .hs_share_li:hover {
      box-shadow: 0px 0 8px 8px rgba(255, 255, 255, 0.4);
      border-radius: 50%;
    }
  }
}
}
</style>